import React, {PureComponent} from 'react';
import styled, {withTheme} from "styled-components";
import Sizes from "../Assets/Sizes";
import {FormattedMessage} from "react-intl";

import {Radio, RadioGroup, FormControlLabel, FormControl, FormLabel} from '@material-ui/core';
import {valueOrDefault} from "@tomeravni/easybizy-js-common/common";
import {GENDER_TYPE} from "../Common/constants";

const Wrapped = styled.div`
    display: flex;
    flex-direction: column;
`

const ServiceLabel = styled.div`
    font-size: 90%;
    padding: ${Sizes.smallMargin} ${Sizes.mediumPadding} 0 ${Sizes.mediumPadding};
`;

const AdaptedRadioGroup = styled(RadioGroup)`
    * {
        font-family: var(--app-font);
    }
`

const SubLabel = styled.div`
    color: ${p => p.theme.colors.secondaryColor};
    font-size: ${Sizes.smallText};
`

class PickGender extends PureComponent {
    modifyGender = (idx, evt) => {
        const totalQuantity = this.props.quantity * this.props.item.PickGenderCount;
        const currentGender = valueOrDefault(this.props.value, []);
        const adaptedMap = [...new Array(totalQuantity)].map((_, idx) => currentGender[idx] || GENDER_TYPE.ANY);
        adaptedMap[idx] = evt.target.value;
        this.props.onChange(adaptedMap);
    }

    cancelEvent = (evt) => {
        evt.stopPropagation();
        evt.preventDefault();
    }

    createGenderPicker = (idx, showIndex) => {
        const currentGender = valueOrDefault(this.props.value, [])[idx] || GENDER_TYPE.ANY;

        let label = (
            <ServiceLabel id="demo-row-radio-buttons-group-label"><FormattedMessage id="gender"/></ServiceLabel>);
        if (showIndex) {
            label = (
                <ServiceLabel id="demo-row-radio-buttons-group-label"><FormattedMessage id="gender"/>&nbsp;
                    <FormattedMessage id="Therapist"/>&nbsp;{idx + 1}
                </ServiceLabel>);

        }

        return (
            <div style={{marginTop: `${(idx > 0 ? Sizes.smallMargin : 0)}`}} key={`gender-${idx}`}>
                <FormControl key={`pick-gender-${idx}`}>
                    {label}
                    <AdaptedRadioGroup
                        value={currentGender}
                        onChange={this.modifyGender.bind(this, idx)}
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                    >
                        <FormControlLabel value={GENDER_TYPE.ANY} control={<Radio/>}
                                          label={<FormattedMessage id="either_gender"/>}
                                          onClick={this.cancelEvent}/>
                        <FormControlLabel value={GENDER_TYPE.FEMALE} control={<Radio/>} label={<FormattedMessage id="woman"/>}
                                          onClick={this.cancelEvent}/>
                        <FormControlLabel value={GENDER_TYPE.MALE} control={<Radio/>} label={<FormattedMessage id="man"/>}
                                          onClick={this.cancelEvent}/>
                    </AdaptedRadioGroup>
                </FormControl>
            </div>)
    }

    render() {
        const {quantity, item, pickGenderMessage} = this.props;
        const toReturn = [...new Array(quantity)].map((_, i) => {
            const toReturn = [];
            [...new Array(item.PickGenderCount)].forEach((_, idx) => {
                const calculatedIndex = i * item.PickGenderCount + idx;
                toReturn.push(this.createGenderPicker(calculatedIndex, item.PickGenderCount > 1 || quantity > 1))
            });

            return <div key={`pick-${i}`}>
                {toReturn}
            </div>

        });

        if (toReturn.length > 0 && pickGenderMessage) {
            toReturn.push(<SubLabel key={'gender-label'}>*&nbsp;{pickGenderMessage}</SubLabel>)
        }

        return (
            <Wrapped>
                {toReturn}
            </Wrapped>
        )
    }
}

export default withTheme(PickGender);
